// extracted by mini-css-extract-plugin
var _1 = "ProfileActivityPanel__body--mcCzV general__body--iyUvL";
var _2 = "ProfileActivityPanel__headerTitle--HHtJm";
var _3 = "ProfileActivityPanel__heading--C0qn9 fontSize__profileSmall--v0KsO";
var _4 = "ProfileActivityPanel__lText--VcoRF ProfileActivityPanel__left--LHFCA";
var _5 = "ProfileActivityPanel__lTitle--MZ_ka";
var _6 = "ProfileActivityPanel__left--LHFCA";
var _7 = "ProfileActivityPanel__main--aLo8i general__panel--NbC8B general__shadow--ifbUf";
var _8 = "ProfileActivityPanel__rText--QaL6Z ProfileActivityPanel__right--IaNBq";
var _9 = "ProfileActivityPanel__right--IaNBq";
var _a = "ProfileActivityPanel__row--rLWIQ";
export { _1 as "body", _2 as "headerTitle", _3 as "heading", _4 as "lText", _5 as "lTitle", _6 as "left", _7 as "main", _8 as "rText", _9 as "right", _a as "row" }
